/* RESPONSIBLE TEAM: team-ml */
import ProductSettingsRoute from 'embercom/routes/apps/app/settings/base/product-settings-route';
import { ReactRoute } from 'embercom/lib/react-route';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

class TeammatesRoute extends ProductSettingsRoute {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  analytics = {
    place: 'teammates-attributes',
  };

  get titleToken() {
    return this.intl.t('new-settings.submenu.data.teammates');
  }

  beforeModel(transition: Transition) {
    super.beforeModel(transition);

    if (!this.appService.app.canUseFeature('wfm-v0')) {
      this.router.transitionTo('apps.app.settings');
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(TeammatesRoute);
